// extracted by mini-css-extract-plugin
export default {"quantity-link":"quantity_quantity-link__lnWN3","quantity-icon":"quantity_quantity-icon__ElS0E","btn":"quantity_btn__Zhy0j","quantity-input":"quantity_quantity-input__eQRoc"};